import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Drawer,
  Grid,
  Pagination,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import ShortByDropdown from "./ShortByDropdown";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import SearchChip from "./SearchChip";
import SearchDrawer from "./SearchDrawer";
import SearchedCourse from "./SearchedCourse";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import SearchEmptyCard from "./SearchEmptyCard";
import SearchTab from "./SearchTab";
import TracksCards from "../../components/Tracks/TracksCards";

import styles from "./SearchResult.module.css";
import { toTitleCase } from "../../hooks/HelperFunctions";
import { useSearchParams } from "next/navigation";

const SearchResult = (props) => {
  const {
    searchBoxText,
    courses,
    totalCourseCount,
    setUpdateCart,
    enrollNowHandler,
    sortByHandler,
    courseLimit,
    setCourseLimit,
    checkboxHandler,
    topicData,
    courseLanguages,
    educators,
    setEducators,
    courseLevels,
    progressionData,
    coursePrice,
    tracks,
    searchFor,
    setSearchFor,
    searchPage,
    setOpenSignUpModel,
  } = props;

  const searchParams = useSearchParams();

  const query = searchParams.get("q");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleShowMore = () => {
    let limit = courseLimit + 9;

    setCourseLimit(limit);
  };

  //== onlclick active class Start ==//
  const [isActive, setActive] = useState("false");

  const handleOpenFilter = () => {
    setActive(!isActive);
  };

  useEffect(() => {
    console.log(query, typeof query);
  }, [query]);
  //== onlclick active class End ==//
  return (
    <>
      <div className={isActive ? "FilterDrawerBody" : "FilterActiveDrawer"}>
        <div className={styles.SearchResult}>
          {searchPage && (
            <div className={styles.FilterButtonContainer}>
              <div className={styles.FilterButtonLeftCol}>
                <li>
                  <StyledButton
                    variant={!isActive ? "contained" : "outlined"}
                    onClick={handleOpenFilter}
                    startIcon={<TuneRoundedIcon />}
                    // sx={{ color: !isActive ? "white" : "black" }}
                  >
                    Filters
                  </StyledButton>
                </li>

                <li>
                  <ShortByDropdown onSelect={sortByHandler} />
                </li>
                <li>
                  <SearchTab
                    searchFor={searchFor}
                    setSearchFor={setSearchFor}
                  />
                </li>
                <li>
                  <SearchChip
                    checkboxHandler={checkboxHandler}
                    topicData={topicData}
                    courseLanguages={courseLanguages}
                    courseLevels={courseLevels}
                    progressionData={progressionData}
                    coursePrice={coursePrice}
                  />
                </li>
              </div>

              <div className={styles.FilterResult}>
                <span>
                  {totalCourseCount} {""}
                  {searchFor === "courses"
                    ? toTitleCase(searchFor?.slice(0, -1))
                    : toTitleCase(searchFor)}
                  {totalCourseCount > 1 ? "s" : ""} Available
                </span>
                {/* <span>{totalCourseCount} results</span> */}
              </div>
            </div>
          )}

          <div className={styles.FilterResultBody}>
            {searchPage && (
              <div className="DrawerBox">
                <div className="FilterResultHeader">
                  <div className="FilterMobileTitle">Filter</div>
                  <button
                    onClick={handleOpenFilter}
                    style={{
                      background: "#374151",
                      borderRadius: "24px",
                      border: "none",
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_15826_6)">
                        <path
                          d="M7.09045 6.00156L11.1665 1.92555C11.24 1.85451 11.2987 1.76954 11.339 1.67558C11.3794 1.58163 11.4006 1.48058 11.4015 1.37833C11.4024 1.27608 11.3829 1.17468 11.3442 1.08004C11.3055 0.985398 11.2483 0.899417 11.176 0.827113C11.1037 0.754808 11.0177 0.697627 10.9231 0.658907C10.8284 0.620187 10.727 0.600703 10.6248 0.601592C10.5225 0.60248 10.4215 0.623724 10.3275 0.664083C10.2336 0.704442 10.1486 0.763108 10.0776 0.836658L6.00156 4.91267L1.92555 0.836658C1.78031 0.696382 1.58578 0.618763 1.38387 0.620517C1.18196 0.622272 0.988817 0.70326 0.846039 0.846039C0.70326 0.988817 0.622272 1.18196 0.620517 1.38387C0.618763 1.58578 0.696382 1.78031 0.836658 1.92555L4.91267 6.00156L0.836658 10.0776C0.763108 10.1486 0.704442 10.2336 0.664083 10.3275C0.623724 10.4215 0.60248 10.5225 0.601592 10.6248C0.600703 10.727 0.620187 10.8284 0.658907 10.9231C0.697627 11.0177 0.754808 11.1037 0.827113 11.176C0.899417 11.2483 0.985398 11.3055 1.08004 11.3442C1.17468 11.3829 1.27608 11.4024 1.37833 11.4015C1.48058 11.4006 1.58163 11.3794 1.67558 11.339C1.76954 11.2987 1.85451 11.24 1.92555 11.1665L6.00156 7.09045L10.0776 11.1665C10.2228 11.3067 10.4173 11.3844 10.6193 11.3826C10.8212 11.3809 11.0143 11.2999 11.1571 11.1571C11.2999 11.0143 11.3809 10.8212 11.3826 10.6193C11.3844 10.4173 11.3067 10.2228 11.1665 10.0776L7.09045 6.00156Z"
                          fill="#E5E7EB"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_15826_6">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>

                {topicData && (
                  <SearchDrawer
                    label="TOPIC"
                    checkboxesData={topicData}
                    checkboxHandler={(index, checkbox) =>
                      checkboxHandler(index, checkbox, "topicData")
                    }
                  />
                )}
                {coursePrice && (
                  <SearchDrawer
                    label="PRICE"
                    checkboxesData={coursePrice}
                    checkboxHandler={(index, checkbox) =>
                      checkboxHandler(index, checkbox, "coursePrice")
                    }
                  />
                )}
                {/* <SearchDrawer label="TYPE" checkboxesData={type} /> */}
                {courseLevels && (
                  <SearchDrawer
                    label="LEVEL"
                    checkboxesData={courseLevels}
                    checkboxHandler={(index, checkbox) =>
                      checkboxHandler(index, checkbox, "courseLevels")
                    }
                  />
                )}
                {courseLanguages && (
                  <SearchDrawer
                    label="LANGUAGE"
                    checkboxesData={courseLanguages}
                    checkboxHandler={(index, checkbox) =>
                      checkboxHandler(index, checkbox, "courseLanguages")
                    }
                  />
                )}
                {educators && (
                  <SearchDrawer
                    label="EDUCATOR"
                    checkboxesData={educators}
                    checkboxHandler={(index, checkbox) =>
                      checkboxHandler(index, checkbox, "educators")
                    }
                  />
                )}
                {progressionData && (
                  <SearchDrawer
                    label="PROGRESSION"
                    checkboxesData={progressionData}
                    checkboxHandler={(index, checkbox) =>
                      checkboxHandler(index, checkbox, "progressionData")
                    }
                  />
                )}
              </div>
            )}

            <div className="SearchContentBox">
              {courses && courses?.length > 0 ? (
                <>
                  <SearchedCourse
                    col={isActive ? "4" : "4"}
                    courses={courses}
                    setUpdateCart={setUpdateCart}
                    enrollNowHandler={enrollNowHandler}
                    setOpenSignUpModel={setOpenSignUpModel}
                    Diploma="DIPLOMA TRACK"
                  />
                </>
              ) : tracks && tracks.length > 0 ? (
                <TracksCards tracks={tracks} setUpdateCart={setUpdateCart} />
              ) : (
                <SearchEmptyCard
                  icon={
                    <MenuBookRoundedIcon
                      sx={{ width: "24px", height: "24px" }}
                    />
                  }
                  title={
                    query != "" && query != null
                      ? `We couldn't find any exact matches related to "${query}"`
                      : `We couldn't find any exact matches related to ${searchFor[0].toUpperCase()}${searchFor.slice(1)}`
                  }
                  keyword={searchBoxText}
                  description="Try finding a course from our course catalog"
                  showButton
                  btnLabel="Explore courses"
                  btnLink="/search"
                />
              )}
            </div>
          </div>
        </div>

        {courses?.length !== totalCourseCount && (
          <div className={styles.ShowMore}>
            {((courses && courses.length > 0) ||
              (tracks && tracks.length > 0)) && (
              <Button
                onClick={() => {
                  if (searchPage) {
                    handleShowMore();
                  }
                }}
                disabled={courses?.length === totalCourseCount ? true : false}
                href={searchPage ? "" : "/search"}
                variant="outlined"
              >
                Explore all courses
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SearchResult;

const StyledPagination = styled(Pagination)(({ theme }) => ({
  "& .Mui-selected": {
    background: "#004FE0 !important",
    color: "#fff !important",
  },
  "& .MuiButtonBase-root": {
    borderRadius: "8px !important",
  },
  "& .MuiButtonBase-root:hover": {
    background: "#004FE0 !important",
    color: "#fff !important",
  },
  [theme.breakpoints.down("sm")]: {},
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: "1px !important",
  padding: "13px 16px !important",
  boxShadow: "none !important",
  borderColor: "#D2D3D8 !important",
  borderRadius: "10px !important",
  "&.MuiButton-contained": {
    background: "#004FE0",
    color: "#fff !important",
    border: "1px solid #1465C0 !important",
  },
  "&.MuiButton-outlined": {
    color: "#0B132B !important",
    border: "1px solid #D2D3D8 !important",
  },
  "&:hover": {
    boxShadow: "none !important",
  },
  [theme.breakpoints.down("sm")]: {},
}));
